import img1 from '../images/planet/041-totem.png';
import img2 from '../images/planet/042-pipe.png';
import img3 from '../images/planet/043-canyon.png';
import img4 from '../images/planet/046-hat.png';


const dataFeatured = [
    {
        id: 1,
        img: img1,
        title: 'Histoire',
        text: "Plongez dans l'univers fascinant de notre carnaval, une célébration riche en couleurs et en émotions. Apprenez-en plus sur son histoire captivante",
        link: '/histoire'
    },
    {
        id: 2,
        img: img2,
        title: 'Dernières éditions',
        text: "Revivez en images les dernières éditions du Carna'dzons. Découvrez les plus beaux costumes et les plus belles photos de notre carnaval",
        link: '/edition'
    }, 
    {
        id: 3,
        img: img3,
        title: 'Carnaval des enfants',
        text: 'Retrouvez toutes les informations sur le Carnaval des enfants, une journée dédiée aux plus petits et à leurs familles',
        link: '/carna_enfant'
    }, 
    {
        id: 4,
        img: img4,
        title: 'Comité',
        text: "Rencontrez les membres du comité du Carna'dzons et découvrez les coulisses de l'organisation de notre magnifique carnaval ",
    },
]

export default dataFeatured;